"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfUpdateSportTopPlayerDto = instanceOfUpdateSportTopPlayerDto;
exports.UpdateSportTopPlayerDtoFromJSON = UpdateSportTopPlayerDtoFromJSON;
exports.UpdateSportTopPlayerDtoFromJSONTyped = UpdateSportTopPlayerDtoFromJSONTyped;
exports.UpdateSportTopPlayerDtoToJSON = UpdateSportTopPlayerDtoToJSON;
exports.UpdateSportTopPlayerDtoToJSONTyped = UpdateSportTopPlayerDtoToJSONTyped;
/**
 * Check if a given object implements the UpdateSportTopPlayerDto interface.
 */
function instanceOfUpdateSportTopPlayerDto(value) {
    if (!('sort_order' in value) || value['sort_order'] === undefined)
        return false;
    return true;
}
function UpdateSportTopPlayerDtoFromJSON(json) {
    return UpdateSportTopPlayerDtoFromJSONTyped(json, false);
}
function UpdateSportTopPlayerDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'sort_order': json['sort_order'],
    };
}
function UpdateSportTopPlayerDtoToJSON(json) {
    return UpdateSportTopPlayerDtoToJSONTyped(json, false);
}
function UpdateSportTopPlayerDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'sort_order': value['sort_order'],
    };
}
